const userRoleTagType = {
  methods: {
    getUserRoleTagType(role) {
      if (role.toUpperCase() === 'ADMIN') return 'warning';
      if (role.toUpperCase() === 'DATAADMIN') return 'success';
      return 'info';
    },
  },
};

export default userRoleTagType;
